// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"407":"c5f162ec","436":"8a0b379b","453":"f394a27d","501":"33eae183","606":"0e09c934","821":"f3bfd222","925":"cc474826","969":"7696e40c"}[chunkId] + ".chunk.js";
};